module.exports = __webpack_public_path__ + "img/aog.e2ff2fe8.png";